class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    if (!this.notification) return;

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    if (!this.notification) return;
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    if (!this.notification) return;
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState?.key || parsedState?.items?.[0]?.key || '';

    this.getSectionsToRender().forEach((section) => {
      const targetElement = document.getElementById(section.id);
      if (!targetElement) return;

      const sectionHTML = parsedState?.sections?.[section.id];
      const renderedHTML = this.getSectionInnerHTML(sectionHTML, section.selector, section.fallbackSelector);
      if (renderedHTML === null) return;

      targetElement.innerHTML = renderedHTML;
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: this.cartItemKey
          ? `[id="cart-notification-product-${this.cartItemKey}"]`
          : '[id^="cart-notification-product-"]',
        fallbackSelector: '[id^="cart-notification-product-"]',
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section', fallbackSelector = '.shopify-section') {
    if (!html || typeof html !== 'string') return null;

    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const sectionElement = parsed.querySelector(selector) || parsed.querySelector(fallbackSelector);
    return sectionElement ? sectionElement.innerHTML : null;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
